import {
  EditContextProvider,
  Form,
  SaveButton,
  useEditController,
  useNotify,
  useRefresh,
  useTranslate,
} from 'react-admin';
import { Button as MUIButton, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Resources } from '../../resource';
import TypeConfigForm from './TypeConfigForm';
import { updateAmountRange, RedPacketType, AmountRange } from '../../../services/redpacketService';
import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { PermissionButton } from '../../../../../routes/components/permission-button';

const EditTypeConfig = ({
  id,
  typeFilter,
  onClose,
  record,
}: {
  id: string | number;
  typeFilter: RedPacketType;
  onClose: () => void;
  record: AmountRange;
}) => {
  const notify = useNotify();
  const t = useTranslate();
  const refresh = useRefresh();
  //admin-react component useCreateController hook dateProvider 中被默认返回的 record 覆盖
  const controller = useEditController({
    id,
    resource: Resources.redpacket,
    mutationMode: 'pessimistic',
    mutationOptions: {
      onSuccess: () => {
        notify(t('module.redpacket.updateSuccessful'), { type: 'success' });
        refresh();
        onClose();
      },
      onError: (error: any) => {
        notify(error.message || t('module.redpacket.updateFailed'), { type: 'error' });
      },
    },
  });

  const CustomSaveButton = () => {
    const { handleSubmit, getValues } = useFormContext();
    const onSubmit = async (data: any) => {
      try {
        const resp = await updateAmountRange({
          id: String(id),
          minAmount: data.minAmount ? String(data.minAmount) : undefined,
          maxAmount: data.maxAmount ? String(data.maxAmount) : undefined,
          skewFactor: data.skewFactor,
          isActive: data.isActive,
          description: data.description,
        });
        const respAny = resp as any;
        if (respAny?.errors && respAny.errors.length > 0) {
          throw new Error(respAny.errors[0]?.message );
        }
        notify(t('module.redpacket.updateSuccessful'), { type: 'success' });
        refresh();
        onClose();
      } catch (error: any) {
        notify(error.message || t('module.redpacket.updateFailed'), { type: 'error' });
      }
    };
    return <MUIButton onClick={handleSubmit(onSubmit)}>{t('actions.save')}</MUIButton>;
  };

  if (controller.isLoading || !controller.record) return null;

  return (
    <EditContextProvider value={controller}>
      <Form disableInvalidFormNotification defaultValues={controller.record}>
        <DialogTitle>{t("module.redpacket.editRedPacketTypeConfiguration")}</DialogTitle>
        <DialogContent>
          <TypeConfigForm isCreate={false} typeFilter={typeFilter} record={record} />
        </DialogContent>
        <DialogActions>
          <MUIButton variant="outlined" onClick={onClose}>
            {t('actions.cancel')}
          </MUIButton>
          <PermissionButton resource="redpacket" action="update">
            <CustomSaveButton />
          </PermissionButton>
        </DialogActions>
      </Form>
    </EditContextProvider>
  );
};

export default EditTypeConfig;
